import swal from 'sweetalert'
import { privateAPI } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'
import * as generalTypes from '../types/generalTypes'

export const getVendorOffers = (type) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/get-vendor-offers`, {
      data: { type },
    })
    if (res) {
      dispatch({
        type: generalTypes.VENDOR_OFFERS,
        payload: decrypt(res.data),
      })
    }
  }
}

export const createOffer = (payload) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/create-offer`, {
      data: { ...payload },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch(getVendorOffers())
      swal('', resp.message, 'success')
    }
  }
}

export const toggleOffer = (offerId, status) => {
  return async (dispatch) => {
    const res = await privateAPI.post(`/general/toggle-offer-status`, {
      data: {
        offerId,
        status,
      },
    })
    if (res) {
      let resp = decrypt(res.data)
      dispatch(getVendorOffers())
      swal('', resp.message, 'success')
    }
  }
}
